'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const utils = require('../utils.js');
const hsla = require('./hsla.js');
const rgba = require('./rgba.js');
const hex = require('./hex.js');

var color = {
  test: function (v) {
    return rgba.rgba.test(v) || hex.hex.test(v) || hsla.hsla.test(v);
  },
  parse: function (v) {
    if (rgba.rgba.test(v)) {
      return rgba.rgba.parse(v);
    } else if (hsla.hsla.test(v)) {
      return hsla.hsla.parse(v);
    } else {
      return hex.hex.parse(v);
    }
  },
  transform: function (v) {
    return utils.isString(v) ? v : v.hasOwnProperty('red') ? rgba.rgba.transform(v) : hsla.hsla.transform(v);
  }
};

exports.color = color;
